<div [class.class-container]="isGroupClass">
    <wizard-labeled-field
        [label]="datePickerLabel"
        size="small"
        [isSecondaryLabel]="!isGroupClass"
        [shouldHideTooltip]="true"
        [isPaired]="true"
        class="block"
    >
        <div *ngIf="isGroupClass" class="wizard-tooltip">
            <wizard-tooltip>
                Set the scheduled time that the Group class / event will occur.
                <a href="https://faq.calendarhero.com/article/232-how-to-schedule-a-group-class" target="_blank"
                    >Learn More</a
                >
            </wizard-tooltip>
        </div>

        <div *ngIf="isGroupClass" class="group-class-description">
            Offer class / event at the following date and time
        </div>
        <div class="field--paired-container field--compact">
            <div class="compact-item">
                <div class="ui calendar" id="dateStart" #date>
                    <div class="ui input left icon">
                        <i class="calendar icon blue"></i>
                        <input type="text" placeholder="Select a date" [ngModel]="dateStart | date: dateFormat" />
                    </div>
                </div>
            </div>
            <div class="divider">at</div>
            <div class="compact-item no-shrink">
                <div class="ui selection dropdown" id="timeStart" [ngClass]="{ 'loading teal': isLoading }" #time>
                    <input type="hidden" name="timeEnd" />
                    <i class="dropdown icon"></i>
                    <div class="default text">Select time</div>
                </div>
            </div>
        </div>
    </wizard-labeled-field>
</div>
